import * as React from 'react'
import { ThemeProvider, CSSReset, RockUITheme } from '@rockr/rock-ui'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import Root from './pages/Root'
import configureStore from './shared/store'

export const App = () => (
  <ThemeProvider theme={RockUITheme}>
    <CSSReset />

    <Provider store={configureStore()}>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
)
